import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAlgoliaDataHitsTotal } from 'selectors/algolia2/data'
import { getSelectedFacetsCount } from '../selectors/facets'

const mapStateToProps = createStructuredSelector({
  facetCount: getSelectedFacetsCount,
  totalHits: getAlgoliaDataHitsTotal,
})

export type ConnectorProps = {
  facetCount: number
  totalHits: number
}

export default connect(mapStateToProps)
